<template>
  <div class="modifyMobilePhoneBox">
    <div class="modifyMobilePhoneBox_step">
      <div class="modifyMobilePhoneBox_step_auto">
        <ul class="clearfix_">
          <li :class="{border:step==1}" class="fl clearfix_"><em :class="{bg:step==1}">1</em><span :class="{color:step==1}" class="">验证身份</span></li>
          <li :class="{border:step==2}" class="fl clearfix_"><em :class="{bg:step==2}">2</em><span :class="{color:step==2}" class="">绑定手机</span></li>
          <li :class="{border:step==3}" class="fl clearfix_"><em :class="{bg:step==3}">3</em><span :class="{color:step==3}" class="">修改绑定成功</span></li>
        </ul>
      </div>
    </div>
    <div v-show="step==1" class="modifyMobilePhoneBox_content">
      <div class="modifyMobilePhoneBox_content_mobilephone">手机号：{{num}}</div>
      <div class="modifyMobilePhoneBox_content_code clearfix_"><input class="fl" v-model="code" placeholder="请输入短信验证码" type="text"><span @click="getcode" class="fl">{{time?time:'获取短信验证码'}}</span></div>
      <div class="modifyMobilePhoneBox_content_btn" @click="submit1">下一步</div>
    </div>
    <div v-show="step==2" class="modifyMobilePhoneBox_content modifyMobilePhoneBox_content_2">
      <div class="modifyMobilePhoneBox_content_fillIn"><input placeholder="请输入需要绑定的手机号" v-model="newNum" type="text"></div>
      <div class="modifyMobilePhoneBox_content_code clearfix_"><input class="fl" v-model="code" placeholder="请输入短信验证码" type="text"><span @click="getcode" class="fl">{{time?time1:'获取短信验证码'}}</span></div>
      <div class="modifyMobilePhoneBox_content_btn" @click="submit1">下一步</div>
    </div>
    <div v-show="step==3" class="modifyMobilePhoneBox_content modifyMobilePhoneBox_content_2">
      <div class="modifyMobilePhoneBox_content_success"><img :src="successPic" alt=""></div>
      <div class="modifyMobilePhoneBox_content_success_txt">恭喜您修改绑定手机成功，{{countDownNum}}秒后自动跳转到个人中心首页。</div>
      <div class="modifyMobilePhoneBox_content_success_btn"><span @click="goToMember">会员中心</span></div>
    </div>
    <div v-show="step!=3" class="modifyMobilePhoneBox_tips">
      <p>手机收不到验证码怎么办：</p>
      <ul>
        <li>1.可能由于网络异常导致，请重新获取或稍后再试</li>
        <li>2.请核实手机是否屏蔽系统短信，已停用或丢失</li>
        <li>3.一个账号一天最多可以发送3条验证短信</li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      step:1,
      num:'',
      newNum:'',
      time:0,
      time1:0,
      code:'',
			isGetCode:false,
      successPic:require('../../assets/img/niu.png'),
      countDownNum:5
    }
  },
  mounted:function(){
    var t_=this
    t_.num=t_.$route.query.num
    // t_.countDownNumFn()
  },
  methods:{
    submit1:function(){
      var t_=this
      if(!t_.code)return this.$message({
        message:'请填写验证码',
        center:true,
        type:'warning'
      })
      var data0bj={
        verifyCode:t_.code
      }
      if(t_.step==1)data0bj.mobile=t_.num
      if(t_.step==2)data0bj.mobile=t_.newNum
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/validationCode`,data0bj).then(res => {
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.message!='success')return this.$message({
          message:'验证码错误',
          center:true,
          type:'warning'
        })
        if(t_.step==1){
          t_.step=2
          t_.code=''
          t_.time=0
          t_.time1=0
        }else if(t_.step==2){
          t_.step=3
          t_.countDownNumFn()
        }
      })
    },
    getcode:function(){
      var t_=this
      t_.isGetCode=true
      var data0bj={}
      if(t_.step==1)data0bj.mobilePhone=t_.num
      if(t_.step==2){
        if(!(/\d{11}$/.test(t_.newNum))){
          return t_.$message({
            message:'请输入正确的手机号',
            center:true,
            type:'warning'
          })
        }else{
          data0bj.mobilePhone=t_.newNum
        }
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/WxCode`,data0bj).then(res=>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==1){
          if(t_.step==1){
            t_.time=60
          }
          if(t_.step==2){
            t_.time1=60
          }
          t_.countDown()
        }
        if(res.data.code==2) t_.$message({
          message:res.data.message,
          center:true,
          type:'warning'
        })
      })
    },
    countDown:function(){
      var t_=this
      var fn=function(){
        setTimeout(function(){
          if(t_.step==1){
            t_.time=--t_.time
            if(t_.time>0){
              fn()
            }
          }
          if(t_.step==2){
            t_.time1=--t_.time1
            if(t_.time1>0){
              fn()
            }
          }
        },1000,t_)
      }
      fn()
    },
    goToMember:function(){
      this.$router.push({path:'/member'})
    },
    countDownNumFn:function(){
      var t_=this
      var fn=function(){
        setTimeout(function(){
          t_.countDownNum=--t_.countDownNum
          if(t_.countDownNum>0){
            fn()
          }else{
            t_.goToMember()
          }
        },1000,t_)
      }
      fn()
    },
  }
}
</script>
<style>
  .modifyMobilePhoneBox{
    width: 990px;
    height: 500px;
    background: #fff;
    padding: 60px 40px 45px 40px;
  }
  .modifyMobilePhoneBox_step{
    height: 26px;
    border-bottom: 1px solid #ddd;
  }
  .modifyMobilePhoneBox_step_auto{
    width: 488px;
    height: 26px;
    margin: auto;
  }
  .modifyMobilePhoneBox_step_auto>ul>li{
    width: 130px;
    height: 26px;
    margin-right: 30px;
    text-align: center;
  }
  .modifyMobilePhoneBox_step_auto>ul>li:last-child{
    width: 168px;
    margin-right: 0;
  }
  .modifyMobilePhoneBox_step_auto>ul>li em{
    display: inline-block;
    width: 16px;
    height: 16px;
    background: #ccc;
    color:#fff;
    border-radius: 50%;
    vertical-align:top;	
    margin-top: 1px;
    text-align: center;
    line-height: 16px;
    margin-right: 4px;
  }
  .modifyMobilePhoneBox_step_auto>ul>li .bg{
    background: #ffaa00;
  }
  .modifyMobilePhoneBox_step_auto>ul>li .color{
    color: #ffaa00;
  }
  .modifyMobilePhoneBox_step_auto>ul>.border{
    border-bottom: 1px solid #ffaa00;
  }
  .modifyMobilePhoneBox_step_auto>ul>li span{
    display: inline-block;
    font-size: 16px;
    color:#ccc;
	  vertical-align:top;	
  }
  .modifyMobilePhoneBox_content{
    width: 460px;
    padding: 0 14px;
    height: 153px;
    margin: 0 auto;
    margin-bottom: 104px;
    margin-top:85px;
  }
  .modifyMobilePhoneBox_content_mobilephone{
    margin-bottom: 23px;
  }
  .modifyMobilePhoneBox_content_code{
    margin-bottom: 30px;
  }
  .modifyMobilePhoneBox_content_code input{
    width: 290px;
    height: 48px;
    border: 1px solid #ddd;
    padding-left: 9px;
    font-size: 14px;
  }
  .modifyMobilePhoneBox_content_code span{
    width: 158px;
    height: 48px;
    border: 1px solid #bbb;
    background: #f6f6f6;
    text-align: center;
    line-height: 48px;
    border-left: 0;
    cursor: pointer;
    color:#333;
    font-size: 14px;
  }
  .modifyMobilePhoneBox_content_btn{
    width: 458px;
    height: 38px;
    background: #fa0;
    color: #fff;
    text-align: center;
    line-height: 38px;
    cursor: pointer;
    border-radius: 5px;
    font-size: 20px;
  }
  .modifyMobilePhoneBox_tips{
    width: 878px;
    height: 107px;
    border: 1px solid #ddd;
    margin-left: 45px;
    padding-top: 24px;
    padding-left: 20px;
  }
  .modifyMobilePhoneBox_tips p{
    color: #666;
    margin-bottom: 20px;
  }
  .modifyMobilePhoneBox_tips li{
    margin-bottom: 12px;
    color:#999;
  }
  .modifyMobilePhoneBox_content_2{
    margin-top: 50px;
  }
  .modifyMobilePhoneBox_content_2 .modifyMobilePhoneBox_content_fillIn{
    margin-bottom: 30px;
  }
  .modifyMobilePhoneBox_content_2 .modifyMobilePhoneBox_content_fillIn input{
    width: 449px;
    height: 48px;
    padding-left: 9px;
    border: 1px solid #ddd;
  }
  .modifyMobilePhoneBox_content_success{
    text-align: center;
    margin-bottom: 15px;
  }
  .modifyMobilePhoneBox_content_success_txt{
    font-size: 16px;
    color:#666;
    text-align: center;
    margin-bottom: 25px;
  }
  .modifyMobilePhoneBox_content_success_btn{
    text-align: center;
  }
  .modifyMobilePhoneBox_content_success_btn span{
    display: inline-block;
    width: 100px;
    height: 35px;
    background: #fa0;
    border-radius: 5px;
    text-align: center;
    line-height: 35px;
    color:#fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/modifyMobilePhone.vue